






















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { getCostByCurrency } from "@/lib/moneyHelpers";
import AvailableContentCount from "@/components/AvailabelContentCount";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney";
import TextClamp from "@/components/TextClamp";

export default defineComponent({
  name: "LevelItem",
  components: { FormatMoney, BaseIcon, TextClamp, AvailableContentCount },
  props: {
    priceLevel: { type: Object as PropType<SubscriptionLevel>, required: true },
  },
  setup(props) {
    const cost = computed(() => {
      if (!props.priceLevel.pricePackage) return null;
      return getCostByCurrency(props.priceLevel.pricePackage);
    });
    const price = computed(() => {
      return cost.value?.cost ?? 0;
    });
    const currencyCode = computed(() => {
      return cost.value?.currency ?? undefined;
    });

    return {
      price,
      currencyCode,
    };
  },
});
